import { RJSFValidationError, UiSchema } from '@rjsf/utils';
import { isNumber } from 'lodash';

/**
 * Find the UI Schema property for the UI Schema key.
 *
 * @param keys Eg: .parent.child or parent.child or .parent.0.child
 * @param uiSchema Eg: {parent: {child: {widget: 'WidgetName'}}}
 * @returns value of the keys property eg: {widget: 'WidgetName'}
 */
export function resolve(keys, uiSchema) {
  if (keys.startsWith('.')) {
    keys = keys.substring(1, keys.length);
  }
  return keys.split('.').reduce(function (prev, curr) {
    //check if curr is a number
    //happens if the value is an array
    //if the number is an array i.e .parent.0.child replacing `0` with `items`
    if (!isNaN(curr)) {
      curr = 'items';
    }
    return prev ? (prev = prev[curr]) : undefined;
  }, uiSchema);
}

/**
 * Fetch the CustomErrorMessage based on type
 * Eg. customErrorMessages is
 * [{
 *    type: 'required',
 *    message: 'This is a mandatory field',
 * }]
 * @param customErrorMessages
 * @param type string eg: required
 * @returns message. Eg: This is a mandatory field
 */
export function fetchCustomMessageBasedOnType(customErrorMessages, type) {
  if (Array.isArray(customErrorMessages)) {
    //@TODO Handle for type=patten. Add the pattern along with the final computed message
    const customErrorMessage = customErrorMessages.filter(
      (customErrorMessage) => customErrorMessage?.type === type,
    );
    if (customErrorMessage.length > 0) {
      return customErrorMessage[0].message;
    }
  }
}

/**
 * TransformError is responsible to transform the error and update it with apprepriate error message.
 * @param errors List of RJSFValidationError for the UISchema data.
 * @param uiSchema UiSchema.
 * @returns updated errors with the message obtained from the UiSchema.
 */
export function transformErrors(
  errors: RJSFValidationError[],
  uiSchema?: UiSchema,
): RJSFValidationError[] {
  console.log('ERROR:', JSON.stringify(errors));
  return errors.map((error: RJSFValidationError) => {
    //Fetch the UiSchema key. Eg: '.parent.child'
    //For UI schema as {parent: {child: {widget: 'WidgetName'}}}
    let uiSchemaProperty = error.property;
    let customTransformedMessage = '';
    if (uiSchemaProperty) {
      const errorType = error.name; //Type of error: required, enum etc
      const schema = resolve(uiSchemaProperty, uiSchema);
      const customErrorMessages = schema && schema['ui:customErrorMessages'];
      const globalErrorMessage = schema && schema['ui:globalErrorMessage'];
      const customMessageBasedOnType = fetchCustomMessageBasedOnType(
        customErrorMessages,
        errorType,
      );
      if (customMessageBasedOnType) {
        customTransformedMessage = customMessageBasedOnType;
      } else if (globalErrorMessage) {
        customTransformedMessage = globalErrorMessage;
      }
      if (customTransformedMessage) {
        error.message = customTransformedMessage;
      }
    }
    return error;
  });
}
